<template>
  <div class="feedback">
    <div v-if="isHiddenRibbon" class="ribbon">
      <img src="@/assets/images/like.svg" alt="like">
      <span v-html="$t('feedback.ribbon')"></span>
    </div>

    <div class="inner">
      <div class="inform" v-html="$t('feedback.rating', {rate: feedback.rate, commentsCount: feedback.commentsCount})"></div>

      <div class="data">
        <div class="rating"><span :style='{width: ""+feedback.rating+"%"}'></span></div>

        <h3>{{ feedback.name}}</h3>

        <div class="url">{{ feedback.link}}</div>

        <p v-html="feedback.comment"></p>
      </div>
    </div>

  </div>
</template>

<script>
  import { DOMAIN_TYPE, FLOW } from '@/constants';

  export default {
    name: "Feedback",
    DOMAIN_TYPE,
    FLOW,
    props: {
      initialData: { type: [Array, Object] },
      domainType: { type: String },
      flow: { type: String }
    },
    computed: {
      isHiddenRibbon() {
        return this.domainType !== DOMAIN_TYPE.DEDICATED && this.domainType !== DOMAIN_TYPE.SSL && this.flow !== FLOW.DOMAIN
      },
      feedback() {
        return !this.initialData ? [] : {
          name: this.initialData.feedback.name,
          link: this.initialData.feedback.www,
          comment: this.initialData.feedback.comment_short,
          rating: this.initialData.feedback.rate_general * 10,

          rate: this.initialData.feedback_rate_data.total_rate,
          commentsCount: this.initialData.feedback_rate_data.comments_count,
        }
      }
    }
  }
</script>

<style lang="scss">
  .feedback {
    padding-bottom: 23px;
    position: relative;

    @media (max-width: $desktop) {
      display: none;
    }

    &:before {
      content: "";
      position: absolute;
      bottom: -26px;
      right: 25px;
      width: 0;
      height: 0;
      border-bottom: 26px solid transparent;
      border-left: 35px solid transparent;
      border-top: 25px solid $white;
    }
    &:after {
      content: "";
      position: absolute;
      bottom: -21px;
      right: 27px;
      width: 0;
      height: 0;
      border-bottom: 25px solid transparent;
      border-left: 32px solid transparent;
      border-top: 23px solid $base-bg-color;
    }

    .inner {
      border: 2px solid $white;
      border-radius: 7px;
    }

    .ribbon {
      margin-bottom: 16px;
    }

    .inform {
      padding-bottom: 25px;
      border-bottom: 2px solid $white;

      @media (max-width: $desktop) {
        text-align: center;
      }

      b {
        display: inline-block;
        font-size: 22px;
        line-height: 1;
      }

      .rate {
        background-color: $white;
        border-radius: 5px;
        padding: 1px;
      }

      span {
        font-size: 14px;
        display: block;
        padding-top: 5px;
      }
    }

    .inform,
    .data {
      padding: 16px 20px 9px;
    }

    .data {
      padding-bottom: 22px;
    }

    .rating {
      margin-bottom: 14px;
    }

    h3 {
      font-size: 24px;
      font-weight: 400;
      margin-bottom: 2px;
      text-transform: capitalize;
    }

    .url {
      font-size: 14px;
      padding-bottom: 15px;
    }

    p:last-child {
      margin-bottom: 0;
      font-size: 16px;
    }

  }

  .ribbon {
    padding: 12px;
    font-weight: 700;
    color: $green;
    position: relative;
    z-index: 1;
    min-height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 300px;
    font-size: 16px;
    border: 2px solid $green;
    border-radius: 7px;
    background-color: #EDFCF7;
    font-size: 16px;
    line-height: 1;

    @media (max-width: $desktop) {
      margin: 0 auto;
    }

    img {
      width: 35px;
      height: 31px;
      display: block;
    }

    span {
      padding-left: 10px;
    }
  }
</style>
